import React, { useState } from "react";
import { B2BLeadDashboard } from "./b2bleaddashboard";
import { B2CLeadDashboard } from "./b2cleadashboard";

const LeadDashboard = () => {
  const accountType = Number(localStorage.getItem("accountType"));

  const [activeAccount, setActiveAccount] = useState(
    accountType === 2 ? "B2C" : "B2B"
  );

  return (
    <>
      {accountType === 1 || accountType === 3 ? (
        activeAccount === "B2B" ? (
          <B2BLeadDashboard onSwitchAccount={setActiveAccount} />
        ) : (
          <B2CLeadDashboard onSwitchAccount={setActiveAccount} />
        )
      ) : accountType === 2 ? (
        <B2CLeadDashboard onSwitchAccount={setActiveAccount} />
      ) : null}
    </>
  );
};

export default LeadDashboard;